import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withRoot from '../withRoot';
import DiceUtil from '../utils/DiceUtil';
import { IconButton, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Switch, List, ListItem, ListItemText, Collapse, ListItemSecondaryAction, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import CasinoIcon from '@material-ui/icons/Casino';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Spells from './Spells.json';

const styles = theme => ({
    root: {
        margin: theme.spacing.unit,
    },
    expansion: {
        width: "800px",
    },
    levelText: {
        width: "90px",
    },
    classText: {
        width: "180px",
    },
    sourceText: {
        width: "220px",
    },
});

class SpellRoller extends Component {
    constructor(props) {
        super(props);

        this.state = {
            result: null,
            levels: Array(Spells.levels.length).fill(false),
            classes: Array(Spells.classes.length).fill(false),
            sources: Array(Spells.sources.length).fill(false),
            isOpen: {},
        };
    }

    handleOpenChange = name => () => {
        const isOpen = Object.assign({}, this.state.isOpen, { [name]: !this.state.isOpen[name] });
        this.setState({
            isOpen: isOpen,
        });
    };

    handleLevelToggle = index => () => {
        const levels = this.state.levels.concat();
        levels[index] = !levels[index];
        this.setState({ levels: levels });
    };

    handleClassToggle = index => () => {
        const classes = this.state.classes.concat();
        classes[index] = !classes[index];
        this.setState({ classes: classes });
    };

    handleSourceToggle = index => () => {
        const sources = this.state.sources.concat();
        sources[index] = !sources[index];
        this.setState({ sources: sources });
    };

    isSpellInFilter(spell, availableLevels, availableClasses, availableSources) {
        if (availableLevels.length > 0) {
            if (availableLevels.indexOf(spell.level) === -1) return false;
        }

        if (availableClasses.length > 0) {
            let foundAvailableClass = false;
            for (let i = 0; i < availableClasses.length; i++) {
                if (spell.classes.indexOf(availableClasses[i]) >= 0) {
                    foundAvailableClass = true;
                    break;
                }
            }
            if (!foundAvailableClass) return false;
        }

        if (availableSources.length > 0) {
            if (availableSources.indexOf(spell.source) === -1) return false;
        }

        return true;
    }

    getAvailableLevels() {
        const levels = this.state.levels;
        const availableLevels = [];
        for (let i = 0; i < levels.length; i++) {
            if (levels[i]) availableLevels[availableLevels.length] = Spells.levels[i];
        }
        return availableLevels;
    }

    getAvailableClasses() {
        const classes = this.state.classes;
        const availableClasses = [];
        for (let i = 0; i < classes.length; i++) {
            if (classes[i]) availableClasses[availableClasses.length] = Spells.classes[i];
        }
        return availableClasses;
    }

    getAvailableSources() {
        const sources = this.state.sources;
        const availableSources = [];
        for (let i = 0; i < sources.length; i++) {
            if (sources[i]) availableSources[availableSources.length] = Spells.sources[i];
        }
        return availableSources;
    }

    getSpellsInFilter() {
        const availableLevels = this.getAvailableLevels();
        const availableClasses = this.getAvailableClasses();
        const availableSources = this.getAvailableSources();

        const mySpells = [];
        for (let i = 0; i < Spells.values.length; i++) {
            let spell = Spells.values[i];
            if (this.isSpellInFilter(spell, availableLevels, availableClasses, availableSources)) {
                mySpells[mySpells.length] = spell;
            }
        }
        return mySpells;
    }

    rollSpell() {
        const mySpells = this.getSpellsInFilter();
        const roll = DiceUtil.dice(mySpells.length) - 1;
        this.setState({ result: mySpells[roll].name });
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <ExpansionPanel className={classes.expansion}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Filters</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>

                        <List>
                            <ListItem button onClick={this.handleOpenChange("level")}>
                                <ListItemText primary="Level" />
                                {this.state.isOpen["level"] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </ListItem>
                            <Collapse in={this.state.isOpen["level"]}>
                                <List component="div" disablePadding>
                                    {Spells.levels.map((value, index) => (
                                        <ListItem key={index}>
                                            <ListItemText primary={value} className={classes.levelText} />
                                            <ListItemSecondaryAction>
                                                <Switch onChange={this.handleLevelToggle(index)} checked={this.state.levels[index]} />
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>
                        </List>

                        <List>
                            <ListItem button onClick={this.handleOpenChange("classes")}>
                                <ListItemText primary="Class" />
                                {this.state.isOpen["classes"] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </ListItem>
                            <Collapse in={this.state.isOpen["classes"]}>
                                <List component="div" disablePadding>
                                    {Spells.classes.map((value, index) => (
                                        <ListItem key={index}>
                                            <ListItemText primary={value} className={classes.classText} />
                                            <ListItemSecondaryAction>
                                                <Switch onChange={this.handleClassToggle(index)} checked={this.state.classes[index]} />
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>
                        </List>

                        <List>
                            <ListItem button onClick={this.handleOpenChange("sources")}>
                                <ListItemText primary="Source" />
                                {this.state.isOpen["sources"] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </ListItem>
                            <Collapse in={this.state.isOpen["sources"]}>
                                <List component="div" disablePadding>
                                    {Spells.sources.map((value, index) => (
                                        <ListItem key={index}>
                                            <ListItemText primary={value} className={classes.sourceText} />
                                            <ListItemSecondaryAction>
                                                <Switch onChange={this.handleSourceToggle(index)} checked={this.state.sources[index]} />
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>
                        </List>

                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel className={classes.expansion}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Spells</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Level</TableCell>
                                    <TableCell>Classes</TableCell>
                                    <TableCell>Source</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.getSpellsInFilter().map((value, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row">{value.name}</TableCell>
                                        <TableCell>{value.level}</TableCell>
                                        <TableCell>{value.classes.map(p => p).reduce((prev, curr) => [prev, ', ', curr])}</TableCell>
                                        <TableCell>{value.source}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <Typography>
                    <IconButton color="inherit" aria-label="Roll" onClick={() => this.rollSpell()}>
                        <CasinoIcon />
                    </IconButton>

                    {this.state.result}
                </Typography>
            </div>
        );
    }
}

SpellRoller.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRoot("Spell Roller", withStyles(styles)(SpellRoller));


// WEBPACK FOOTER //
// ./src/item-helpers/SpellRoller.js